import { produce } from 'immer';

import { ConsentsState } from './state.interface';
import { ConsentsActionsType } from './actions';
import { ActionType } from 'app/store/actionTypes';

const initialState: ConsentsState = {
  shouldCheckIfConsentResetRequired: {
    email: false,
    phoneNumber: false,
    mainOwner: {
      name: false,
      lastName: false,
      peselNumber: false,
    },
    insurant: {
      name: false,
      lastName: false,
      peselNumber: false,
    },
  },
};

const consentsReducer = (
  state: ConsentsState = initialState,
  action: ConsentsActionsType
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActionType.SET_SHOULD_CHECK_IF_CONSENT_RESET_REQUIRED:
        draft.shouldCheckIfConsentResetRequired = {
          ...draft.shouldCheckIfConsentResetRequired,
          ...action.payload,
          mainOwner: {
            ...draft.shouldCheckIfConsentResetRequired.mainOwner,
            ...action.payload.mainOwner,
          },
          insurant: {
            ...draft.shouldCheckIfConsentResetRequired.insurant,
            ...action.payload.insurant,
          },
        };
        return;
      default:
        return state;
    }
  });

export default consentsReducer;
